// Module
var code = `<div class="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
  <h1 class="font-lusitana mb-3 text-2xl">{{heading}}</h1>
  <div class="w-full">
    <div>
      <label
        class="mb-3 mt-5 block text-xs font-medium text-gray-900"
        for="email"
        >{{emailLabel}}</label
      >
      <div class="relative">
        <input
          class="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
          id="email"
          type="email"
          name="email"
          placeholder="{{emailPlaceholder}}"
          required
        />
        {{svgAtSymbol}}
      </div>
    </div>
    <div class="mt-4">
      <label
        class="mb-3 mt-5 block text-xs font-medium text-gray-900"
        for="password"
        >{{passwordLabel}}</label
      >
      <div class="relative">
        <input
          class="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
          id="password"
          type="password"
          name="password"
          placeholder="{{passwordPlaceholder}}"
          required
          minlength="6"
        />
        {{svgKey}}
      </div>
    </div>
  </div>
  <input type="hidden" name="redirectTo" value="{{attrRedirectTo}}" />
  <!-- No data-acme-action here: the form's submit event carries the credentials.
       Tagging the button as well would fire a second request with no email or
       password attached. -->
  <button
    type="submit"
    class="mt-4 w-full flex h-10 items-center rounded-lg bg-blue-500 px-4 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600"
  >
    {{loginLabel}}{{svgArrowRight}}
  </button>
  <div
    class="flex h-8 items-end space-x-1"
    aria-live="polite"
    aria-atomic="true"
    data-slot="error"
  ></div>
</div>
`;
// Exports
module.exports = code;